import React, { useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap';
import moment from "moment-jalaali";
import { fetchUserProfile } from '../../../../redux/action/userProfile/user-profile';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import MainLoading from '../../../../utils/MainLoading';
import { useTranslation } from 'react-i18next';

const DeatilsModal = (props) => {
    const dispatch = useDispatch()
    const userprofile = useSelector(state => state.user_profile)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')

    useEffect(() => {
        dispatch(fetchUserProfile(props.id))
    }, [props.id])

    return (
        <>
            {props.show && (
                <Modal show={props.show} size="lg">
                    {userprofile.loading ?
                        <MainLoading />
                    :
                        <>
                            <Modal.Header>
                                <Modal.Title>{t("company details")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("company name")} : </span><span>{userprofile.user.title}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("situation")} : </span><span>{userprofile.user.is_block === 1  ? "بلاک شده است" : "نمایش داده می‌شود"}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("username")} : </span><span>{userprofile.user.username}</span></div>

                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("CEO name")} : </span><span>{userprofile.user.manager_name}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("CEO phone number")} : </span><span>{userprofile.user.manager_mobile}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("email address")} : </span><span>{userprofile.user.email  ? userprofile.user.email : "-"}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("explanations")} : </span><span>{userprofile.user.description ? userprofile.user.description : '-'}</span></div>

                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("Central office address")} : </span><span>{userprofile.user.address ? userprofile.user.address : '-'}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("Central office phone")} : </span><span>{userprofile.user.phone ? userprofile.user.phone : '-'}</span></div>
                                    
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("province")} : </span><span>{userprofile.user.province ? userprofile.user.province : '-'}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("city")} : </span><span>{userprofile.user.city ? userprofile.user.city : '-'}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("Location of the factory")} : </span><span>{userprofile.user.location ? userprofile.user.location : '-'}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("area where the factory is located")} : </span><span>{userprofile.user.zone ? userprofile.user.zone : '-'}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span> {t("full address")} : </span><span>{userprofile.user.factory_address ? userprofile.user.factory_address : '-'}</span></div>

                                    {userprofile.created_at && <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("create date")} : </span>
                                        <span> 
                                            {lang === 'en' ?
                                                userprofile.user.created_at.substr(11, 5)+' - '+userprofile.user.created_at && userprofile.user.created_at.substr(0, 10)
                                            :
                                                userprofile.user.created_at.substr(11, 5)+' - '+moment(userprofile.user.created_at && userprofile.user.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                            }
                                        </span>
                                    </div> }
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={props.handleClick}>
                                    {t("close")}
                                </Button>
                            </Modal.Footer>
                        </>
                    }
                    
                </Modal>
            )}
        </>
      );

}

export default DeatilsModal

